import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useOutletContext } from "react-router-dom";
import MarketplaceEmployeeOrder from "./MarketplaceEmployeeOrder";
import MarketplaceGuestOrder from "./MarketplaceGuestOrder";
import MarketplaceOtherOrder from "./MarketplaceOtherOrder";
import MarketplaceMenuSection from "components/marketplace/marketplaceBase/MarketplaceMenuSection";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import BaseSelect from "components/shared/baseForm/BaseSelect";
import { Button } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { useGetMarketplaceByFacilitySelectQuery, useGetMarketplaceByIdQuery, useAddMarketplaceOrderMutation, useAddMarketplaceOrderWithCardMutation } from "store/apis/MarketplaceApi";
import { useGetResidentsAllQuery } from "store/apis/ResidentsApi";

dayjs.extend(customParseFormat);

const TAB_STYLES = (active) => ({
  backgroundColor: active ? "#375e66" : "#e0e0e0",
  color: active ? "#fff" : "#000",
  fontWeight: "bold",
  textTransform: "none",
  borderRadius: "8px",
  height: "2.5rem",
  boxShadow: "none",
  "&:hover": { backgroundColor: active ? "#375e66" : "#d0d0d0" },
});

export default function MarketplaceGuest() {
  const currentUserData = useOutletContext();

  const methods = useForm({ shouldUnregister: false, mode: "all" });
  const { watch, setValue, getValues, reset } = methods;
  const { data: residents } = useGetResidentsAllQuery();

  const orderType = watch("orderType", 1); // 1=Guest, 2=Employee, 3=Other
  const marketplaceId = watch("marketplaceId");
  const selectedGuestOfId = watch("guestOfResidentId", 0);

  const { data: marketplaces } = useGetMarketplaceByFacilitySelectQuery(
    currentUserData?.facilityId,
    { skip: !currentUserData?.facilityId }
  );

  const [addMarketplaceOrder, { isLoading: isSubmitting }] = useAddMarketplaceOrderMutation();

  const [addMarketplaceOrderWithCard, { isLoading: isSubmittingWithCard }] = useAddMarketplaceOrderWithCardMutation();

  const {
    data: menuData,
    isFetching: menuDataLoading,
  } = useGetMarketplaceByIdQuery(
    { id: marketplaceId, residentId: 0 },
    { skip: !marketplaceId, refetchOnMountOrArgChange: 300 }
  );

  useEffect(() => {
    if (!marketplaceId) return;
    localStorage.setItem("lastMarketplaceId", marketplaceId);
  }, [marketplaceId]);

  useEffect(() => {
    if (!marketplaces?.length) return;
    const saved = localStorage.getItem("lastMarketplaceId");
    if (saved && marketplaces.some((m) => m.id == saved)) {
      setValue("marketplaceId", Number(saved));
    }
  }, [marketplaces]);

  // Reset type-specific fields and errors when switching tabs
  useEffect(() => {
    setValue("guestName", "");
    setValue("employeeId", 0);
    setValue("guestOfResidentId", 0);
    methods.clearErrors();
  }, [orderType]);

  const handleOrderSubmit = async (billingTypeId, selectedItems, orderTotal) => {
    const empId = getValues("employeeId");
    const name = getValues("guestName");
    if (orderType === 1 && !selectedGuestOfId) {
      methods.setError("guestOfResidentId", { message: "Please select a resident" });
      return false;
    }
    if (orderType === 1 && !name) {
      methods.setError("guestName", { message: "Name is required" });
      return false;
    }
    if (orderType === 2 && !empId) {
      methods.setError("employeeId", { message: "Employee is required" });
      return false;
    }
    if (orderType === 3 && !name?.trim()) {
      methods.setError("guestName", { message: "Name is required" });
      return false;
    }

    if (billingTypeId === 1) {
      console.log(billingTypeId);
    const result = await addMarketplaceOrderWithCard({
      facilityId: currentUserData?.facilityId,
      bistroMenuId: marketplaceId,
      residentId: null,
      guestOfResidentId: orderType === 1 ? (selectedGuestOfId || null) : null,
      employeeId: orderType === 2 ? (empId || null) : null,
      guestName: name || null,
      guestTypeId: orderType,
      price: orderTotal,
      billingTypeId,
      orderItems: Object.values(selectedItems).map((item) => ({
        bistroMenuItemId: item.id,
        itemName: item.name,
        category: item.bistroMenuCategoryName ?? "",
        subcategory: item.bistroMenuSubCategoryName ?? "",
        quantity: item.quantity,
        price: item.price ?? 0,
        note: item.note ?? "",
        subItems: Object.values(item.subItems || {}).map((sub) => ({
          bistroMenuSubItemId: sub.id,
          itemName: sub.name,
          quantity: sub.quantity,
          price: sub.price ?? 0,
        })),
      })),
    }).unwrap();

      console.log('***********',result);
    //window.location.href = result.checkoutUrl;
    if (!result.error && result?.status === 'succeeded') {
      window.alert(
        `(SIMULATION) Payment successful!\nOrder: ${result.orderId}\nPayment: ${result.paymentIntentId}`
      );

      reset({ marketplaceId });
    } else {
      window.alert('(SIMULATION) Payment has not completed. Check its status before retrying.');
      return !result.error;
}
    //if (!result.error) reset({ marketplaceId });
    //return !result.error;
    }
    else {  
    const result = await addMarketplaceOrder({
      facilityId: currentUserData?.facilityId,
      bistroMenuId: marketplaceId,
      residentId: null,
      guestOfResidentId: orderType === 1 ? (selectedGuestOfId || null) : null,
      employeeId: orderType === 2 ? (empId || null) : null,
      guestName: name || null,
      guestTypeId: orderType,
      price: orderTotal,
      billingTypeId,
      orderItems: Object.values(selectedItems).map((item) => ({
        bistroMenuItemId: item.id,
        itemName: item.name,
        category: item.bistroMenuCategoryName ?? "",
        subcategory: item.bistroMenuSubCategoryName ?? "",
        quantity: item.quantity,
        price: item.price ?? 0,
        note: item.note ?? "",
        subItems: Object.values(item.subItems || {}).map((sub) => ({
          bistroMenuSubItemId: sub.id,
          itemName: sub.name,
          quantity: sub.quantity,
          price: sub.price ?? 0,
        })),
      })),
    });
        if (!result.error) reset({ marketplaceId });
    return !result.error;
  }

  };

  const showChargeResident = orderType === 1 && selectedGuestOfId > 0;

  return (
    <div className="paperContent customScrollbar">
      <Box width="100%" padding="0 1rem">
        <FormProvider {...methods}>
          <Grid container spacing={2} sx={{ alignItems: "center" }}>
            <Grid size={{ xs: 8 }}>
              <Grid container spacing={2}>
                {[
                  { label: "Employee Order", value: 2 },
                  { label: "Guest Order", value: 1 },
                  { label: "Other", value: 3 },
                ].map(({ label, value }) => (
                  <Grid size={4} key={value}>
                    <Button variant="contained" fullWidth sx={TAB_STYLES(orderType === value)} onClick={() => setValue("orderType", value)}>
                      {label}
                    </Button>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid size={{ xs: 4 }}>
              <BaseSelect
                name="marketplaceId"
                id="marketplaceId"
                label="Marketplace"
                control={methods.control}
                options={marketplaces || []}
                sx={{ width: "100%" }}
              />
            </Grid>

            <Grid size={{ xs: 12 }}>
              {orderType === 1 && <MarketplaceGuestOrder residents={residents} />}
              {orderType === 2 && <MarketplaceEmployeeOrder facilityId={currentUserData?.facilityId} />}
              {orderType === 3 && <MarketplaceOtherOrder />}
            </Grid>

            {menuData?.isMenuAvailable && marketplaceId ? (
              <MarketplaceMenuSection
                menuData={menuData}
                menuDataLoading={menuDataLoading}
                isSubmitting={isSubmitting || isSubmittingWithCard}
                showChargeResident={showChargeResident}
                onOrderSubmit={handleOrderSubmit}
                marketplaceId={marketplaceId}
              />
            ) : (menuData && !menuData?.isMenuAvailable) ? (
              <Grid size={{ xs: 12 }} width="100%">
                <Typography variant="h5" textAlign="center" gutterBottom sx={{ whiteSpace: "pre-line" }}>
                  {"This marketplace is not currently available."}{!!menuData?.bistroMenuSchedules?.length && "\nAvailability:"}
                </Typography>
                {!!menuData?.bistroMenuSchedules?.length && menuData.bistroMenuSchedules.map((schedule) => (
                  <Grid size={{ xs: 12 }} key={schedule.dayOfWeek} sx={{ display: "flex", flexWrap: "nowrap" }}>
                    <Grid size={{ xs: 6 }} pr={2}>
                      <Typography textAlign="right" fontSize="1.25rem">{dayjs().day(schedule.dayOfWeek).format("dddd")}</Typography>
                    </Grid>
                    <Grid size={{ xs: 6 }} pl={2}>
                      {schedule.isAvailable ? (
                        <Typography textAlign="left" fontSize="1.25rem">
                          {dayjs(schedule.startTime, "HH:mm:ss").format("h:mm A")} - {dayjs(schedule.endTime, "HH:mm:ss").format("h:mm A")}
                        </Typography>
                      ) : (
                        <Typography textAlign="left" fontSize="1.25rem">Not Available</Typography>
                      )}
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Grid size={{ xs: 12 }}>
                <Typography variant="h5" textAlign="center">Please select a marketplace</Typography>
              </Grid>
            )}

          </Grid>
        </FormProvider>
      </Box>
    </div>
  );
}